var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.711,
    y1: 0.323,
    x2: 0.052,
    y2: 0.926,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0075f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#005dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0253ae"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_61661",
    x: 180.684,
    y: 184.82,
    width: 137.042,
    height: 103.155,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.341
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_18",
    "data-name": "Artboard \\u2013 18",
    clipPath: "url(#clip-Artboard_18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235185",
    "data-name": "Group 235185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19172",
    "data-name": "Rectangle 19172",
    width: 500,
    height: 500,
    rx: 91,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_235182",
    "data-name": "Group 235182",
    transform: "translate(109.863 103.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235183",
    "data-name": "Group 235183",
    transform: "translate(0 198.874)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "pay_me",
    "data-name": "pay me",
    transform: "translate(0 74)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 79,
    fontFamily: "Raleway-Bold, Raleway",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PAY "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#f7b933"
  }, "ME"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_235181",
    "data-name": "Group 235181",
    transform: "translate(70.473 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234995",
    "data-name": "Group 234995",
    transform: "translate(9.848 88.409)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -190.18, -191.44)",
    filter: "url(#Path_61661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61661-2",
    "data-name": "Path 61661",
    d: "M2.66,82.216A106.375,106.375,0,0,1,4.374,62.257a54.107,54.107,0,0,1,6-16.531,55.554,55.554,0,0,1,11.755-14.2c4.98-4.408,14.6-14.211,22.269-18.456.127-.068,2.087-1.809,2.61-2.1C53.674,6.6,59.431,1.311,64.476-1.331c5.143-2.694,45.532,6.4,42.267,9.833A61.287,61.287,0,0,1,96.09,17.44q-5.755,3.8-11.143,6.735-4.408,2.449-10.041,5.633t-11.143,6.98A114.846,114.846,0,0,0,53.6,44.624a36.4,36.4,0,0,0-7.1,7.959h74.2V82.216Z",
    transform: "translate(187.52 193.26)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_235180",
    "data-name": "Group 235180",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 8.721, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61662",
    "data-name": "Path 61662",
    d: "M61.843,34.689q-3.836.547-5.765.812a1.521,1.521,0,0,0-1.133.78,1.74,1.74,0,0,0-.154,1.435,88.721,88.721,0,0,1,2.689,10.65,1.634,1.634,0,0,0,.7,1.09,1.431,1.431,0,0,0,1.216.217c2.771-.719,4.651-1.208,5.814-1.511a1.7,1.7,0,0,0,1.159-2.027A73.748,73.748,0,0,0,63.5,35.717a1.544,1.544,0,0,0-1.66-1.028Zm31.577,17.42c-8.042-40.773-30.444-58.361-64.2-50.13l-.385.035h.238c-.762.187-1.527.383-2.3.6,20,.212,32.82-.476,47.195,17.76,5.317,6.743,8.719,16.085,11.141,27.065q-15.662,4.707-31.326,9.411Q46.661-2.051,0,7.754C45.824,8.807,43.346,48.226,35.469,77l46.987.107a112.637,112.637,0,0,0-.228-18.113L75.6,61.079a95.725,95.725,0,0,1,.032,9.607L43.1,70.475c2.041-11.606,2.993-24.093.319-34.506,3.787,9.072,3.574,20.854,3.018,30.939L75.357,57.78l0,.018,6.488-2.043,0-.012,11.575-3.634Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 41.958, 0)",
    fill: "#f7b933",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61663",
    "data-name": "Path 61663",
    d: "M47.814,62.994q.095-3.194.33-6.166H42.289c-.222,2.1-.38,4.167-.472,6.166Zm.707-10.063q3.371-29.11,21.459-34.749C65.862,7.727,58.388,2.57,49.783.664,28.677-4.007.992,15.888,0,62.994H5c.239-5.027.683-9.721,1.294-13.936a76.319,76.319,0,0,1,2.96-13.216,29,29,0,0,1,7.862.652,95.7,95.7,0,0,0-3.083,13.848q-.176,1.212-.331,2.483H20.2a132.255,132.255,0,0,1,2.337-13.5,104.1,104.1,0,0,1,3.731-12.67,25.141,25.141,0,0,1,8.442.191,88.725,88.725,0,0,0-4.557,14.486,131.641,131.641,0,0,0-2.991,21.661h6.82a118.57,118.57,0,0,1,4.631-27.978,58.127,58.127,0,0,1,6.927-15.548,27.263,27.263,0,0,1,9.535,1.355c-3.653,2.833-6.714,9.171-9,16.761a104.594,104.594,0,0,0-3.3,15.346ZM13.288,56.722c-.185,2.01-.333,4.1-.441,6.272h6.457q.175-3.192.469-6.272Z",
    transform: "translate(0 9.15)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b7a274808c5ac903d4692d2a3d19735d.svg";
export { ForwardRef as ReactComponent };